import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CircleIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='circle'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<circle
				cx='12'
				cy='12'
				r='7.5'
				stroke='#2E2E6B'
			/>
		</svg>
	);
};

export default CircleIcon;
